import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchAuthChange_password = z.any()
export type TagsPatchAuthChange_password = z.infer<typeof tagsPatchAuthChange_password>

export const bodyPatchAuthChange_password = z.object({ "oldPassword": z.string(), "newPassword": z.string(), "confirmPassword": z.string() })
export type BodyPatchAuthChange_password = z.infer<typeof bodyPatchAuthChange_password>

export const responsePatchAuthChange_password = z.object({})
export type ResponsePatchAuthChange_password = z.infer<typeof responsePatchAuthChange_password>

interface IPatchAuthChange_password extends BaseMethodType {
  tags: TagsPatchAuthChange_password,
  body: BodyPatchAuthChange_password,
  response: ResponsePatchAuthChange_password
}
export const URL = '/auth/change-password'
export const validation = {
  patch: {
    tags: tagsPatchAuthChange_password,
    body: bodyPatchAuthChange_password,
    response: responsePatchAuthChange_password
  }
}
export interface AuthChange_password extends BaseRouteType {
  patch: IPatchAuthChange_password
}